module.exports = __webpack_public_path__ + "img/house6.14e21a29.png";